import { useState } from 'react';

export const useSeoInput = () => {
  const [url, setUrl] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  return { url, setUrl, error, setError };
};
